import axios from 'axios'
import store from '../../store'

export default {
  data() {
    return {}
  },
  methods: {
    listEmuladores: function() {
      this.carregaTexto(this.codeMensagem('C01'))
      return new Promise((resolve, reject) => {
        axios
          .get(
            store.state.baseUrlSegurancaSGP + 'Emulados/listartodosemula',
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error)
          })
          .finally(this.carregaTexto)
      })
    },
    listEmulados: function() {
      this.carregaTexto(this.codeMensagem('C01'))
      return new Promise((resolve, reject) => {
        axios
          .get(
            store.state.baseUrlSegurancaSGP + 'Emulados/listartodosemulado',
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error)
          })
          .finally(this.carregaTexto)
      })
    },
    listEmuladosPorId: function(usuID) {
      this.carregaTexto(this.codeMensagem('C01'))
      return new Promise((resolve, reject) => {
        axios
          .get(
            store.state.baseUrlSegurancaSGP + 'Emulados/listartodosemuladoporusuid?usuID=' + usuID,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error)
          })
          .finally(this.carregaTexto)
      })
    },
    insereEmulador: function(usuID) {
      const emula = {
        usuEmuID: 0,
        usuID: usuID
      }
      this.carregaTexto(this.codeMensagem('C01'))
      return new Promise((resolve, reject) => {
        axios
          .post(
            store.state.baseUrlSegurancaSGP + 'Emulados/incluiremula',
            emula,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error)
          })
          .finally(this.carregaTexto)
      })
    },
    deleteEmulador: function(usuEmuID) {
      this.carregaTexto(this.codeMensagem('C01'))
      return new Promise((resolve, reject) => {
        axios
          .delete(
            store.state.baseUrlSegurancaSGP + 'Emulados/excluiremula?usuEmuID=' + usuEmuID,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error)
          })
          .finally(this.carregaTexto)
      })
    }
  }
}
